import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  slideIn: {
    animation: `$slideIn 0.5s forwards`,
  },
  slideOut: {
    animation: `$slideOut 0.5s forwards`,
  },
  "@keyframes slideIn": {
    from: { transform: "translateX(100%)", opacity: 0 },
    to: { transform: "translateX(0)", opacity: 1 },
  },
  "@keyframes slideOut": {
    from: { transform: "translateX(0)", opacity: 1 },
    to: { transform: "translateX(100%)", opacity: 0 },
  },
  titulo: {
    height: "73px",
    padding: "31px",
    display: "flex",
    Justify: "space-between",
    alignItems: "center",
    fontFamily: "Roboto",
    fontSize: "20px",
    lineHeight: "25px",
    letterSpacing: "-0.25px",
    color: theme.palette.neutral400,
    backgroundColor: theme.palette.backgroundl100,
  },
  tituloBranco: {
    height: "73px",
    padding: "31px",
    display: "flex",
    justify: "space-between",
    alignItems: "center",
    fontFamily: "Roboto",
    fontSize: "20px",
    lineHeight: "25px",
    letterSpacing: "-0.25px",
    color: theme.palette.neutral400,
    backgroundColor: theme.palette.background100,
  },
  boxNovaConversa: {
    position: "absolute",
    right: 0,
    top: 0, // Ajuste conforme necessário
    margin: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    width: 400,
    borderRadius: "12px",
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 768px)": {
      minWidth: "100%",
      width: "100%",
      minHeight: "100%",
      borderRadius: "0px",
    },
  },
  iconButton: {
    marginLeft: "auto", // Empurra o botão para o final
    padding: "8px",
    borderRadius: theme.radius.radius300,
    gap: "8px",
    width: "40px",
    height: "40px",
  },
  iconX: {
    color: theme.palette.neutral400,
  },
  content: {
    backgroundColor: theme.palette.background200,
    paddingLeft: "32px",
    paddingRight: "32px",
    overflow: "hidden",

    "@media (max-width: 768px)": {
      paddingLeft: "7%",
      paddingRight: "7%",
    },
  },
  contentScrollable: {
    backgroundColor: theme.palette.background200,
    paddingLeft: "32px",
    paddingRight: "32px",
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",

    "@media (max-width: 768px)": {
      paddingLeft: "7%",
      paddingRight: "7%",
    },
  },
  contentBranco: {
    backgroundColor: theme.palette.background100,
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    height: "auto",
    padding: "0 !important",
    overflow: "hidden !important",
    "&.MuiDialogContent-root": {
      padding: "0 !important",
      overflowY: "hidden !important",
      "&::-webkit-scrollbar": { width: 0, height: 0 },
    },
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "@media (max-width: 768px)": {
      padding: "0 !important",
    },
  },
  contentContato: {
    backgroundColor: theme.palette.background100,
    paddingLeft: "32px",
    paddingRight: "32px",
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 200px)",
    overflow: "hidden",

    "@media (max-width: 768px)": {
      paddingLeft: "7%",
      paddingRight: "7%",
      height: "calc(100vh - 180px)",
    },
  },
  header: {
    display: "flex",
    backgroundColor: theme.palette.backgroundl100,
    alignItems: "center",
    padding: "24px",
    minHeight: "104px",
    justifyContent: "flex-start",
  },
  dadosContato: {
    backgroundColor: theme.palette.background100,
    gap: "17px",
    display: "flex",
    flexDirection: "column",
    paddingRight: "24px",
    paddingLeft: "24px",
    paddingTop: "16px",
    paddingBottom: "16px",
    maxHeight: "100px",
    ...theme.scrollbarStyles,
  },
  dadosContatoGrande: {
    backgroundColor: theme.palette.background100,
    gap: "17px",
    display: "flex",
    flexDirection: "column",
    paddingRight: "24px",
    paddingLeft: "24px",
    paddingTop: "16px",
    ...theme.scrollbarStyles,
  },
}))

export default useStyles
